import {greenTick, cardIcon, cancelIcon} from "@img"
import {useUpcomingTrips} from '@/hooks/useTrips'
import {parseCard, formatPrice} from '@/utils/functions'
import CardBrand from '@/customComponents/uiComponents/global/CardBrand.jsx'
import RetryHoldButtons from '@/customComponents/RideView/RetryHoldButtons.jsx'

export default function PaymentMethods() {
    const {data, isLoading} = useUpcomingTrips({page: 1, perPage: 5})
    const trip = data?.trips?.find(t => t.status !== 'Requested' && t.status !== 'Draft')
    const {brand, last4} = parseCard(trip?.selected_payment_method)
    const paymentHold = trip?.payment_hold
    const isAuthorized = paymentHold?.is_authorized
    const isCaptured = paymentHold?.is_captured
    const hasCard = Boolean(trip?.card_hold_amount_cents)
    const hasWallet = (trip?.wallet_amount_cents ?? 0) > 0
    const isPaymentHoldFailed = isAuthorized === false || isCaptured === false

    if (!isLoading && !trip) return null

    return (
        <div className="white-global-section">
            <div className="flex items-center gap-2 mb-10">
                <img src={cardIcon} alt="card"/>
                <h4 className="mb-0!">Payment Methods</h4>
            </div>

            {isLoading ? (
                <>
                    <div className="animate-pulse h-10 w-40 bg-gray-200 rounded-full mb-10"/>
                    <div className="animate-pulse h-6 w-48 bg-gray-200 rounded"/>
                </>
            ) : (
                <>
                    <div className="flex flex-wrap gap-3 mb-10">
                        {hasCard && (
                            <div className="bg-(--accent-green-light) text-(--text-primary) rounded-full px-10 py-2.5 inline-flex items-center gap-2">
                                <span className="font-bold text-sm text-gray-900"><CardBrand brand={brand} alt={brand || 'card'}/></span>
                                **** {last4 || '----'}
                            </div>
                        )}
                        {hasWallet && (
                            <div className="bg-(--accent-green-light) text-(--text-primary) rounded-full px-10 py-2.5 inline-flex items-center gap-2">
                                Credit: {formatPrice(trip.wallet_amount_cents, {decimals: 2})}
                            </div>
                        )}
                    </div>

                    {hasCard && isCaptured === true && (
                        <div className="flex items-center gap-2 text-lg mb-0">
                            <img alt="success" src={greenTick} className="mr-2"/>
                            <span>Captured successfully</span>
                        </div>
                    )}
                    {hasCard && isCaptured === false && (
                        <div className="flex items-center gap-2 text-lg mb-0">
                            <img alt="failed" src={cancelIcon} className="mr-2"/>
                            <span>Credit card payment failed, retry or add new card</span>
                        </div>
                    )}
                    {hasCard && isCaptured == null && isAuthorized === true && (
                        <div className="flex items-center gap-2 text-lg mb-0">
                            <img alt="success" src={greenTick} className="mr-2"/>
                            <span>Pre-authorized<br/> hold placed</span>
                        </div>
                    )}
                    {hasCard && isCaptured == null && isAuthorized === false && (
                        <div className="flex items-center gap-2 text-lg mb-0">
                            <img alt="failed" src={cancelIcon} className="mr-2"/>
                            <span>Credit card payment failed, retry or add new card</span>
                        </div>
                    )}

                    {isPaymentHoldFailed && <RetryHoldButtons trip={trip}/>}
                </>
            )}
        </div>
    )
}
